import { useCallback } from 'react';
import { getContainer } from '@framework/di/getContainer';
import {
  useCorporateBondScreenerMySelectionContext,
} from '@/creditflowresearch/application/CorporateBondScreener/CorporateBondScreenerMySelectionContext';
import { useBondScreenerColumnsContext } from '@/creditflowresearch/application/BondScreener/BondScreenerColumnsContext';
import { ROW_TYPE_TRANCHE } from '@/creditflowresearch/application/BondScreener/rowType';
import {
  tagTranche,
  type ICorporateBondScreenerTrancheRow,
} from '@/creditflowresearch/application/CorporateBondScreener/useCorporateBondScreener';
import {
  getTrancheId,
  type ICorporateBondScreenerMySelectionValue,
} from '@/creditflowresearch/application/CorporateBondScreener/useCorporateBondScreenerMySelection';
import useMySelectionAutoSync from '@/creditflowresearch/ui/common/hooks/useMySelectionAutoSync';
import BondScreenersRepository from '@/creditflowresearch/infrastructure/repository/BondScreenersRepository';

export const useMySelectionSync = (): ICorporateBondScreenerMySelectionValue => {
  const selection = useCorporateBondScreenerMySelectionContext();
  const { activeColumnsIds } = useBondScreenerColumnsContext();
  const { selectedItems, isGroupStale, markGroupSynced, replaceItems } = selection;
  const repository = getContainer().get<BondScreenersRepository>(BondScreenersRepository);

  const fetchFresh = useCallback(async (
    ids: string[],
    columnIds: readonly string[],
  ): Promise<ICorporateBondScreenerTrancheRow[]> => {
    const response = await repository.getSelectedCorporateTranches({ ids, columns: [...columnIds] });

    return response.collection.map(tagTranche);
  }, [repository]);

  useMySelectionAutoSync<ICorporateBondScreenerTrancheRow>({
    groupKey: ROW_TYPE_TRANCHE,
    isGroupStale,
    markGroupSynced,
    selectedItems,
    replaceItems,
    activeColumnsIds,
    fetchFresh,
    getId: getTrancheId,
  });

  return selection;
};

export default useMySelectionSync;
